// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_emeCi","link":"link_1u7ok","menu":"menu_2IHgk","menu__item":"menu__item_2luif","logout":"logout_2G6IX"};